import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ViewManagerService } from '../../../../core/services/view-manager-service';
import { ScadenzarioFormComponent } from '../../../form/scadenzario/scadenzario-form.component';
import { Scadenza } from '../../../models/scadenza';
import { SezioneScadenze } from '../../../models/sezioni/sezione-scadenze';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'div [scadenzario-form-update]',
  templateUrl: '../../../form/scadenzario/scadenzario-form.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class ScadenzaUpdateConcreteFormComponent extends ScadenzarioFormComponent implements OnInit {

  idSezione: string;
  scadenza: Scadenza;
  urlUpdate: string;
  requestSub: Subscription;
  @Output()
  onReturn: EventEmitter<SezioneScadenze> = new EventEmitter<SezioneScadenze>();

  @Output() scadenzaMod:  EventEmitter<Scadenza> = new EventEmitter<Scadenza>();

  constructor(
    @Inject(OperationsService) operationService: OperationsService, 
    @Inject(FormBuilder) campiForm: FormBuilder, 
    @Inject(HelpersService) helpers: HelpersService, 
    private viewManager: ViewManagerService, 
    private modalNotifyService: ModalNotifyService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Modifica dati - Adempimento');
    this.isInserimento(false);
  }

  getScadenza() {
    return this.scadenza;
  }

  getRequest(request: Scadenza) {
    if (request.tipoScadenza.id === 'ATTIVITA' && request.assegnatario) {
      this.requestSub = this.modalNotifyService.notifyConfirmObservable.subscribe(result => {
        this.request.inviaNotifica = result;
        this.operationService.updateScadenza(this.urlUpdate, request, this.idSezione, this.idFascicolo)
          .subscribe(response => this.sezioneScadenzeUpdated(response));
      });
  
      this.modalNotifyService.notifyCustom("Sono state apportate delle modifiche. Confermi di voler rinviare la notifica all'utente assegnatario?");
    } else {
      this.operationService.updateScadenza(this.urlUpdate, request, this.idSezione, this.idFascicolo)
        .subscribe(response => this.sezioneScadenzeUpdated(response));
    }
  }
  

  sezioneScadenzeUpdated(response) {
    if (response.returnCode === 'OK') {
      this.viewManager._prossimiAdempimenti.next({param: null, timeOut:true});
      this.onReturn.emit(response.sezione);
      this.scadenzaMod.emit(this.request);
      this.requestSub.unsubscribe();
    }
  }

  inizializza(url: string, scadenza: Scadenza, idSezione: string, fascicoloGeneric: string,idFascicolo: string) {
    this.urlUpdate = url;
    this.scadenza = scadenza;
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.populateSelect(fascicoloGeneric);
    this.createForm();
  }
}
